import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { TransactionData, TransactionDataMapper, TransactionGridData, TransactionGridDataMapper } from '../features/DTO/transaction';
import { TransactionSearchModel } from '../features/DTO/transaction-search-model';
import { TransactionSummaryData, TransactionSummaryDataMapper,TransactionResultData } from '../features/DTO/transaction-summary';
import { FuncsService } from '../services/funcs.service';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
  })

  export class TransactionService {
    private transactionDataMapper = new TransactionDataMapper();
    private transactionGridDataMapper = new TransactionGridDataMapper();
    constructor(private http: HttpClient, private globalFunc:FuncsService) { 

    }
    getTransactionGrid(transactionSearchModel:TransactionSearchModel) {
      
      let data:any=JSON.stringify(transactionSearchModel);
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
         return this.http.post<TransactionGridData>(environment.transactionListUrl,data,httpOptions)
         .pipe(take(1), map((data: any) => this.transactionGridDataMapper?.mapToModel(data)))
         .pipe(catchError(this.globalFunc.error));
        
    }
    
    getPharmacyVendors(
      searchTerm: string | null = null,
      pageNumber: number | null = null,
      pageSize: number | null = null
    ): Observable<any> {
      let params = new HttpParams();

      if (searchTerm) {
        params = params.set('VendorName', searchTerm); // adjust key if needed
      }
      if (pageNumber !== null) {
        params = params.set('PageNumber', pageNumber.toString());
      }
      if (pageSize !== null) {
        params = params.set('PageSize', pageSize.toString());
      }

      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        params
      };
      return this.http.get(environment.pharmacyListUrl, httpOptions);
    }

    getTransactionSummaryHeader(input: any) {
      const httpOptions = {
        headers: new HttpHeaders({
        'Content-Type':  'application/json'
        })};

      return this.http.post<TransactionResultData>(environment.transactionLookupUrl,input,httpOptions)
      .pipe(catchError(this.globalFunc.error));
    }

    
  }
  